import { useNavigate } from 'react-router-dom'
import Star from './Star'
import noimage from '../images/noimage.jpg'
import styles from '../styles/item.module.css'

function ProductCard({ data }) {
  const navigate = useNavigate()

  const handleCardClick = () => {
    if (data && data._id) {
      navigate(`/product/${data._id}`)
    }
  }

  return (
    <div className={styles.card} onClick={handleCardClick}>
      <div className={styles.imageWrapper}>
        <img src={data.image || noimage} className={styles.image} alt={data.name || 'Product'} />
      </div>

      <div className={styles.body}>
        <h3 className={styles.title}>{data.name || 'Product'}</h3>

        <div className={styles.stars}>
          <Star stars={data.rating || 0} reviews={data.numReviews || 0} />
        </div>

        <div className={styles.price}>${data.price || 0}</div>
      </div>
    </div>
  )
}

export default ProductCard